"use client";
import { Box, Divider, Flex, Heading, Text } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { TEXT_VARIANTS } from "@/theme/components/text";

const CardBody = ({ challenge, results, solutions }) => {
  const TextVariant = useTextVariants();
  return (
    <Flex
      direction="column"
      gap={{ base: "2rem", md: "2.5rem" }}
      p={{ base: 8, md: 20 }}
      backgroundColor={"#F5F5F5"}
      borderRadius={"18px"}
    >
      <Flex gap={{ base: "1rem", md: "5%" }} direction={{ base: "column", md: "row" }}>
        <Box flex="0 0 20%">
          <Heading variant={HEADING_VARIANTS.HEADLINE4} color="#021B66">
            🏆 Challenge :
          </Heading>
        </Box>
        <Box flex="0 0 70%">
          <Text as={"span"} variant={TextVariant} color={"text.100"}>
            {challenge}
          </Text>
        </Box>
      </Flex>
      <Divider color="#DCDCDC" />
      <Flex gap={{ base: "1rem", md: "5%" }} direction={{ base: "column", md: "row" }}>
        <Box flex="0 0 20%">
          <Heading variant={HEADING_VARIANTS.HEADLINE4} color="#021B66">
            💡Solution :
          </Heading>
        </Box>
        <Box flex="0 0 70%">
          <Flex
            direction="column"
            gap="2rem"
            color="text.100"
            width={{ base: "100%", md: "80%" }}
          >
            {solutions.map((solution, index) => (
              <Flex direction="column" gap="1rem" key={index}>
                {solution.label && (
                  <Text variant={TEXT_VARIANTS.LABEL1} color="black" fontWeight={600}>
                    {solution.label}
                  </Text>
                )}
                <Box>
                  {solution.title && (
                    <Text as={"span"} variant={TextVariant} fontWeight={600}>
                      {solution.title}
                    </Text>
                  )}
                  <Text as={"span"} variant={TextVariant}>
                    {solution.desc}
                  </Text>
                </Box>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Flex>
      <Divider color="#DCDCDC" />
      <Flex gap={{ base: "1rem", md: "5%" }} direction={{ base: "column", md: "row" }}>
        <Box flex="0 0 20%">
          <Heading variant={HEADING_VARIANTS.HEADLINE4} color="#021B66">
            🏅 The Results :
          </Heading>
        </Box>
        <Box flex="0 0 70%">
          <Flex
            direction="column"
            gap={"0.8rem"}
            color="text.100"
            width={{ base: "100%", md: "80%" }}
          >
            {results.map((result, index) => (
              <Box key={index}>
                {result.title && (
                  <Text as={"span"} variant={TextVariant} fontWeight={600}>
                    {result.title}
                  </Text>
                )}
                <Text as={"span"} variant={TextVariant}>
                  {result.desc}
                </Text>
              </Box>
            ))}
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
};

export default CardBody;
